import "./releaseNotesDetail.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import desktopViewTable from "../../TableTemplates/DesktopViewTable";
import mobileViewTable from "../../TableTemplates/MobileViewTable";
import SyntaxHighlighter from 'react-syntax-highlighter';
import { renderToString } from 'react-dom/server'
import { IconButton, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useRef } from "react";
import useHandleAnchorClick from "../../../hooks/useHandleAnchorClick";
import { useTranslation } from "react-i18next";
import darkTheme from 'react-syntax-highlighter/dist/esm/styles/hljs/atom-one-dark';
import { cleanDetailsLink, formatXML } from "../../../constants/apiUtil";
import { useDispatch, useSelector } from "react-redux";
import { resetAllReleaseItems, resetPageReload, setReleaseNotesAccordionActive, setReleaseNoteTitle, setShowReleaseDetails } from "../../../redux/slices/staticPagesSlice";

const ReleaseNotesDetail = ({ details, Chip, lang, setRedirectToSub }) => {

  const { t,i18n } = useTranslation();
  const theme = useTheme();
  const size = useMediaQuery(theme.breakpoints.up("md"));
  const handleAnchorClick = useHandleAnchorClick();

  const { clickedReleaseItem, releaseNoteTitle } = useSelector((state: any) => state.staticPages); // Assuming you have a clickedReleaseItem in your state

  const dispatch = useDispatch()

  const [copied, setCopied] = React.useState<null | number>(null);

  const [downloadAnnouncement, setDownloadAnnouncement] = React.useState<string>("");

  const handleCopy = async (text: string, index: number) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(index)
      setTimeout(() => {
        setCopied(null)
      }, 2000);
    }).catch((err) => console.log(err));

  };

  useEffect(() => {
    if (clickedReleaseItem) {
      const handleScrollToElement = () => {
        const elements = document.querySelectorAll('h3, h4');
        elements.forEach((element: any) => {

          if (cleanDetailsLink(element.textContent?.trim()) === cleanDetailsLink(clickedReleaseItem)) {
            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - 300;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth',
            });

          } else if (cleanDetailsLink(releaseNoteTitle) === cleanDetailsLink(clickedReleaseItem)) {
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          }
        });
      }

      // Wait for the DOM to be fully loaded
      const timeoutId = setTimeout(handleScrollToElement, 50);

      return () => clearTimeout(timeoutId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clickedReleaseItem]);


  React.useEffect(() => {
    if (details) {
      dispatch(setReleaseNoteTitle(details.title))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [details])

  React.useEffect(() => {
    const container = document.querySelectorAll('[id^="code-button-"]');
    container.forEach((element: Element, index: number) => {
      element.addEventListener("click", () => {
        handleCopy(element.getAttribute("data-code") || '', index);
      });
    });

    return () => {
      container.forEach((element: Element, index: number) => {
        element.removeEventListener("click", () => {
          handleCopy(element.getAttribute("data-code") || '', index);
        });
      });
    }

  }
    , [copied]);

  const apiServices: any = {
    AirShopping: {
      label: "AirShopping",
      src: "/images/icons/airshopping.png",
      href: "/api/documentation/airshopping/functionality",
    },
    OfferPrice: {
      label: "OfferPrice",
      src: "/images/icons/offerprice.png",
      href: "/api/documentation/offerprice/functionality",
    },
    SeatAvailability: {
      label: "SeatAvailability",
      src: "/images/icons/seatavailability.png",
      href: "/api/documentation/seatavailability/functionality",
    },
    ServiceList: {
      label: "ServiceList",
      src: "/images/icons/servicelist.png",
      href: "/api/documentation/servicelist/functionality",
    },
    OrderCreate: {
      label: "OrderCreate",
      src: "/images/icons/ordercreate.png",
      href: "/api/documentation/ordercreate/functionality",
    },
    OrderRetrieve: {
      label: "OrderRetrieve",
      src: "/images/icons/orderretrieve.png",
      href: "/api/documentation/orderretrieve/functionality",
    },
    OrderReshop: {
      label: "OrderReshop",
      src: "/images/icons/orderreshop.png",
      href: "/api/documentation/orderreshop/functionality",
    },
    OrderCancel: {
      label: "OrderCancel",
      src: "/images/icons/ordercancel.png",
      href: "/api/documentation/ordercancel/functionality",
    },
    OrderChange: {
      label: "OrderChange",
      src: "/images/icons/orderchange.png",
      href: "/api/documentation/orderchange/functionality",
    },
    OrderView: {
      label: "OrderView",
      src: "/images/icons/orderretrieve.png",
      href: "/api/documentation/orderretrieve/functionality",
    },
    OrderChangeNotification: {
      label: "OrderChange<br/>Notification",
      src: "/images/icons/orderchangenotification.png",
      href: "/api/documentation/orderchangenotification",
    },
  };

  let parser = new DOMParser();

  const env = process.env["REACT_APP_ENV_LOADED"];

  let url = `https://content-ndc-portal.aircanada.com/s3fs-public/samples/`; //default to prod
  if (env === "DEV" || env === "INT" || env === "CRT") {
    url = `https://content-ndc-portal-int.aircanada.com/s3fs-public/samples/`;
  } else if (env === "BAT" || env === "PREPROD") {
    url = `https://content-ndc-portal-bat.aircanada.com/s3fs-public/samples/`;
  }
  // let body = content.querySelector("body");
  const updatePREcode = (linkString) => {
    linkString = linkString?.replaceAll("\n ", "");

    // eslint-disable-next-line no-control-regex
    const re = new RegExp("<pre>(.|\n|\r\n)*?</pre>", "g"); //(?<=<pre>)((.|\n|\r\n)*?)(?=</pre>)

    var regex = re,
      result: string[] | null;

    while ((result = regex.exec(linkString))) {
      if (result.hasOwnProperty("index")) {
        const origPreCode = result[0];

        const updatedPreCode = origPreCode
          .replace("<pre>", "")
          .replace("</pre>", "")
          .replaceAll("<", "&#60;")
          .replaceAll(">", "&#62;");

        linkString = linkString.replaceAll(
          origPreCode,
          `<pre>${updatedPreCode}</pre>`
        );

      }
    }

    //also replace any ENV_SAMPLES href w/ env url

    return linkString?.replaceAll("ENV_SAMPLES/", url);
  };

  if (details?.detailsBody)
    details.detailsBody = updatePREcode(details.detailsBody);
  let content = parser.parseFromString(details.detailsBody, "text/html");


  const servicesList: string[] = [];
  if (details?.services && typeof details?.services[0] === "object") {
    //multiple services returned as object w/ value key for title
    details.services.forEach((s) => s?.value && servicesList?.push(s?.value));
  } else {
    details.services?.length > 0 && servicesList.push(details.services);
  }

  let servicesHTML = {};
  let heading = details.title;

  servicesList.forEach((el, i) => {
    servicesHTML[
      el
    ] = `<a href='/${i18n.language}${apiServices[el]?.href}'><div class="affectedApiImg"><img src=${apiServices[el]?.src} alt="" /></div><span>${apiServices[el]?.label}</span></a>`;
  });

  const splitHtml = [] as any;

  const childElements = Array.from(content.body?.children);

  let buttonIterator = 0;

  childElements.forEach((element) => {
    const isTable = element.tagName.toLowerCase() === "table";
    if (
      !isTable &&
      splitHtml.length > 0 &&
      !splitHtml[splitHtml.length - 1].startsWith("<table")
    ) {
      if (element.tagName.toLowerCase() === "pre") {
        const formattedXml = formatXML(element.textContent?.trim()!, '    ')
        splitHtml[splitHtml.length - 1] += renderToString(<div className="code-container">
          <button id={`code-button-${buttonIterator}`} data-code={formattedXml}>{copied === buttonIterator ? 'Copied!' : 'Copy'}</button>
          <SyntaxHighlighter language="xml" style={darkTheme} showLineNumbers>{formattedXml}</SyntaxHighlighter>
        </div>)
        buttonIterator++;
      } else {
        splitHtml[splitHtml.length - 1] += element.outerHTML;
      }
    }

    else {
      // !element.outerHTML.includes("<h2>") &&
      splitHtml.push(isTable ? element.outerHTML : element.outerHTML);
    }
  });

  const getUseCasesContent = (table) =>
    size
      ? desktopViewTable(table, "useCasesTable", "Use Cases Table")
      : mobileViewTable(table, '', handleAnchorClick);


  //since xml files are on separate server, need workaround to force download (devops not able to return content-disposition header...)
  //1. get the hrefs from the XML sample files
  const contentRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (contentRef.current) {

      const links = contentRef.current.querySelectorAll("a");
      links.forEach((link) => {
        link.addEventListener("click", handleClick);
        link.classList.add("xmlsample")
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentRef]);
  //2. handle sample xml clicks
  const handleClick = (event: MouseEvent) => {
    event.preventDefault();
    const url = (event.target as HTMLAnchorElement).href;
    setDownloadAnnouncement("");
    setTimeout(() => {
      setDownloadAnnouncement("Please check your download folder for confirmation.")
    }, 100);
    fetchData(url);
  };
  //3. fetch the file and force download
  const fetchData = (url) => {
    fetch(url)
      .then(res => res.blob())
      .then(blob => {
        const fileName = url.slice(url.lastIndexOf('/') + 1)

        const file = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = file;
        a.download = fileName;
        document.body.appendChild(a); // for firefox
        a.click();
        a.remove();
      });
  }


  const updateXMLurl = (linkString) => {
    const re = new RegExp("<a[^>]*>([^<]+)</a>", "g");
    var regex = re,
      result: string[] | null;
    while ((result = regex.exec(linkString))) {
      if (result.hasOwnProperty("index")) {
        const re = /href="([^"]+)"/g;

        const hrefMatch = result[0].match(re) || [""];
        let hrefMatchString: any = Array.isArray(hrefMatch)
          ? hrefMatch[0]
          : hrefMatch;
        hrefMatchString = hrefMatchString.replace("href=", "").replaceAll('"', "");


        const updatedAtag = result[0]
          .replace(`>${result[1]}`, ` download>${result[1]}`)
          .replace(
            hrefMatchString,
            `${url}${hrefMatchString}`
          );
        linkString = linkString.replace(result[0], updatedAtag);
      }
    }

    return linkString;
  };

  const labelMap = {
    fr: {
      releaseNotifications: "Avis de mise à jour",
      environments: "Vous trouverez ci-dessous les dates prévues des améliorations à nos différents environnements :",
      overView: "Aperçu",
      messages: "Exemples de messages",
      affected: "API touchées",
      scope: "Hors du champ d’application",
      limitations: "Restrictions"

    },
    en: {
      releaseNotifications: "Release Notifications",
      environments: "Below are the scheduled dates for enhancements in our different environments:",
      overView: "Overview",
      messages: "Sample Messages",
      affected: "APIs Affected",
      scope: "Out of Scope",
      limitations: "Limitations"
    }
  }

  const currentLanguage = i18n.language || "en";
  const releaseNotifications = labelMap[currentLanguage].releaseNotifications;
  const environments = labelMap[currentLanguage].environments;
  const overView = labelMap[currentLanguage].overView;
  const messages = labelMap[currentLanguage].messages;
  const affected = labelMap[currentLanguage].affected;
  const scope = labelMap[currentLanguage].scope;
  const limitations = labelMap[currentLanguage].limitations;


  return (
    <div className="releaseNotesDetailsContainer">
      <div className="releaseDetailsHeader">
        {" "}
        <IconButton
          className="backArrowIcon"
          onClick={() => {
            dispatch(resetAllReleaseItems());
            dispatch(setReleaseNotesAccordionActive([]));
            dispatch(resetPageReload())
            setRedirectToSub("")
            window.history.pushState({}, "", `/${i18n.language}/api/releasenotes`);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              dispatch(setShowReleaseDetails(false));
              dispatch(setReleaseNoteTitle(""))

              setRedirectToSub("")
              window.history.pushState({}, "", `/${i18n.language}/api/releasenotes`);
            }
          }}
          type="button"
        >
          <ArrowBackIosIcon
          aria-hidden="true"
            sx={{
              width: '.9rem',
              height: '.9rem',
              color: "#000",
            }}
          />
          <span style={{color:"#005078",fontSize:"15px"}}>{t('release_noteDetails.button')}</span>
        </IconButton>
        <h2> {heading}</h2>
        <br />
      </div>
      <div className="releaseNotesDetails">
        <div className="releaseNotificationBar">
          {" "}
          <h3>{releaseNotifications}</h3>
          <p>
            {environments}
          </p>{" "}
          <div className="notificationDates">
            <Chip type="PROD" date={details.envDates?.prod} className="prod" />
            <Chip type="BAT" date={details.envDates?.bat} />
            <Chip type="UAT" date={details.envDates?.uat} />
          </div>
        </div>
        <div className="overviewContainer">
          <h3> {overView}</h3>
          <div
            dangerouslySetInnerHTML={{ __html: details.overview || "" }}
            onClick={handleAnchorClick}
            className="releaseNotesDetails"
          />
        </div>

        {splitHtml.map((html, i) =>
          html.includes("<table>") ? (
            <div key={`t-${i}`}>{getUseCasesContent(html)}</div>
          ) : (
            <div
              key={`rn-${i}`}
              dangerouslySetInnerHTML={{ __html: html || "" }}
              onClick={handleAnchorClick}
              className="releaseNotesDetails"
            />
          )
        )}
      </div>
      {details.xmlSampleFiles && (
        <div className="sampleMessage">
          <h3> {messages}</h3>
          <div
            ref={contentRef}
            dangerouslySetInnerHTML={{
              __html: updateXMLurl(details.xmlSampleFiles),
            }}
            onClick={handleAnchorClick}
          />
        </div>
      )}
      {servicesList?.length > 0 && (
        <div className="affectedApiBar">
          <h3>{affected}</h3>

          <ul>
            {" "}
            {servicesList.map((service) => (
              <li key={service}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: servicesHTML[service] || "",
                  }}
                  onClick={handleAnchorClick}
                />
              </li>
            ))}
          </ul>
        </div>
      )}

      {details?.outOfScope?.length && (
        <>
          {" "}
          <h3>{scope}</h3>
          <div
            dangerouslySetInnerHTML={{ __html: details.outOfScope || "" }}
            onClick={handleAnchorClick}
            className="releaseNotesDetails"
          />{" "}
        </>
      )}
      {details?.limitations?.length && (
        <>
          {" "}
          <h3>{limitations}</h3>
          <div
            dangerouslySetInnerHTML={{ __html: details.limitations || "" }}
            onClick={handleAnchorClick}
            className="releaseNotesDetails"
          />{" "}
        </>
      )}
      <div
        style={{ position: "absolute", left: "-9999px", height: "1px", width: "1px", overflow: "hidden" }}
        aria-live="polite"
        aria-atomic="true"
      >
        {downloadAnnouncement}
      </div>
    </div>
  );
};

export default ReleaseNotesDetail;
